<template>
  <b-col class="main-menu uk-visible@l uk-height-1-1">
    <div class="bsb-logo__wrapper">
      <div class="bsb__demo">
        Демо-режим
      </div>
      <img src="@/assets/images/logo.svg" alt="logotype BSB" @click="goToMainPage" />
    </div>
    <b-menu class="bsb__menu" :items="menuItems"></b-menu>
  </b-col>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'DesktopMenu',
  computed: {
    ...mapState({
      selectedCommunityId: state => state.community.selectedCommunityId
    }),
    menuItems() {
      if (this.$store.state.auth.user == null) return []
      const routes = this.$router.options.routes.reduce((arr, item) => {
        if (item['children']) {
          arr.push(...item['children'])
        }
        return arr
      }, [])
      return routes
        .filter(it => it.display)
        .filter(it => it.meta.authorize.includes(this.$store.state.auth.user.roles[0]))
    }
  },
  methods: {
    goToMainPage() {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bsb {
  &-logo__wrapper {
    flex: 0 0 auto;
    padding-left: 30px;
    padding-right: 30px;
    cursor: pointer;
  }
  &__demo {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  &__menu {
    margin-top: 60px;
  }
}
</style>
